module.exports = __webpack_public_path__ + "img/30_25.7037efcf.png";